<template>
  <div class="ticker-transaction-table">
    <table class="table">
      <thead>
        <tr>
          <th>{{ $t("table.date") }}</th>
          <th>{{ $t("table.account") }}</th>
          <th class="is-hidden-mobile">{{ $t("table.hash") }}</th>
          <th>{{ $t("table.amount") }}</th>
        </tr>
      </thead>
      <tbody v-for="transaction in transactions" :key="transaction.hash">
        <tr>
          <!-- date -->
          <td class="date">
            {{ $utils.formatTimestamp(transaction.timestamp) }}
          </td>
          <!-- account -->
          <td class="account">
            <a class="text-gray" v-bind:href="'#/account/'+ transaction.from">
              {{ transaction.from }}
            </a>
          </td>
          <!-- hash -->
          <td class="hash is-hidden-mobile">
            <a class="text-gray" v-bind:href="'#/tx/'+ $utils.formatHash(transaction.hash)">
              {{ $utils.formatHash(transaction.hash) }}
            </a>
          </td>
          <!-- amount -->
          <td class="amount" :class="amountType()">
            {{ $utils.formatAmount(transaction.value) }} <!-- {{ coinName }} -->
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    name: 'ticker-transaction-table',
    props: ['transactions'],
    computed: {
      coinName () {
        return this.$COINNAME
      }
    },
    methods: {
      amountType () {
        return 'text-white'
      }
    }
  }
</script>

<style lang="scss" scoped>
  .content {
    table {
      thead {
        tr {
          border: 1px solid #4acb6b;
          border-width: 0 0 1px;
        }
        th {
          background-color: #e5e5e5;
          color: #000;
        }
      }
      tbody {
        td {
          background-color: #f8f8f8ba;
          border: 1px solid #4acb6b;
          border-width: 0 0 1px;
          color: #666;
          font-weight: 500;
        }
      }
    }
  }

  .text-white {
    color: #fff;
  }
  .text-gray {
    color: #666;
  }

</style>



// WEBPACK FOOTER //
// src/components/layout/TickerTransactionTable.vue